module.exports = __webpack_public_path__ + "img/img-example.281d235d.png";